import { render, staticRenderFns } from "./accesses-report-chart.vue?vue&type=template&id=27090a01&"
import script from "./accesses-report-chart.vue?vue&type=script&lang=ts&"
export * from "./accesses-report-chart.vue?vue&type=script&lang=ts&"
import style0 from "./accesses-report-chart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports